
/* injects from baggage-loader */

'use strict';

export default class EditDocumentModalController {

	constructor($log) {
		'ngInject';

		this.$log = $log;
		this.isGroup = false;

	}

	$onInit() {

		// Set modal context
		this.context = this.resolve.context;
		this.document = this.context.document.toJSON();
		this.isGroup = this.document.isGroup;

		// Filter keys needed to edit
		this.document = Object.keys(this.document).reduce((obj, key) => {
			if (['label', 'active', 'protected'].includes(key)) {
				obj[key] = this.document[key];
			}
			return obj;
		}, {})
		this.$log.debug(this.document);

	}

	setProtected(value) {
		this.document.protected = value;
	}

	ok() {

		this.error_msg = '';

		// Trim both values
		['label'].forEach(v => {
			this.document[v] = this.document[v].trim();
		})

		if (!this.document.label) {
			this.error_msg = 'Document label is required';
			return false;
		}

		// Return the document
		this.close({
			$value: this.document
		});

	}

	cancel() {
		this.dismiss({ $value: 'cancel' });
	}

}



// WEBPACK FOOTER //
// ./src/app/components/editDocumentModal/editdocumentmodal.controller.js